
// app/app.js
// Import legacy vendor scripts in the correct order
//window._ = require('lodash');
//window.$ = require('jquery');
//window.angular = require('angular');

//require(
//  'imports-loader?angular=>window.angular!' +
//  'angular-cookies'
//);

/**
 * `require` all modules in the given webpack context
 */
function requireAll(context) {
  context.keys().forEach(context);
}

// Collect all angular modules
requireAll(require.context(
  './src',
  true,
	/^\.\/.*\.js$/
));





// WEBPACK FOOTER //
// ./app.js